import { createStyles, makeStyles } from '@material-ui/core';
import Colors from '../../../../constants/Colors';
import { neutral, orange } from '../../../../shared/styles/colors';

export const CountdownToEditStyle = makeStyles(() =>
  createStyles({
    container: {
      backgroundColor: orange[10],
      borderLeft: `3px solid ${orange[60]}`,
      gridArea: 'disclaimer',
      margin: '0.5rem 0',
    },
    primaryText: {
      color: neutral[100],
      fontFamily: 'PP Object Sans',
      fontSize: '0.875rem',
      fontWeight: 500,
    },
    secondaryText: {
      color: neutral[80],
      fontFamily: 'PP Object Sans',
      fontSize: '0.75rem',
      fontWeight: 500,
    },
    icon: {
      color: orange[60],
      alignSelf: 'center',
    },
    countdownClock: {
      borderRadius: '1.25rem',
      backgroundColor: Colors.WARNING_COLOR,
    },
    clock: {
      color: Colors.BROWN_2,
    },
    time: {
      width: '2.5rem',
      fontSize: '0.875rem',
      fontWeight: 600,
      color: Colors.BROWN_2,
    },
    cta: {
      cursor: 'pointer',
      fontWeight: 700,
      fontSize: '0.75rem',
      color: Colors.BROWN,
    },
  }),
);
